export interface IPermission {
  uuid?: string;
  name?: string;
}
